module.exports = __webpack_public_path__ + "img/banner04.22239401.jpg";